module.exports = __webpack_public_path__ + "static/media/Mentionslegale.6aa03263.pdf";